import { AppSettings } from "../settings/AppSettings";

export class Templates {
	
	public static createElement(htmlString:string):HTMLElement {
		let template = document.createElement("template");
		htmlString = htmlString.replace(/{{r}}/g, AppSettings.resourcesPath);
		template.innerHTML = htmlString;
		let el = template.content.firstElementChild;
		el.remove();
		return el as HTMLElement;
	}
	
	public static createDiv(htmlString:string):HTMLDivElement {
		return Templates.createElement(htmlString) as HTMLDivElement;
	}
}